import React from "react"

const TwitterIcon = () => {
  return (
    // <svg
    //   width="24"
    //   height="24"
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M13.625 10.88L19.5 5H18L12.95 10.04L9 5H4L10.15 12.84L4 19H5.5L10.825 13.68L15 19H20L13.625 10.88ZM6.225 5.93333H8.225L17.75 18.0667H15.75L6.225 5.93333Z"
    //     fill="white"
    //   />
    // </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <g clipPath="url(#clip0_12168_38184)">
        <path
          d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 22.9091C5.97506 22.9091 1.09092 18.0249 1.09092 12C1.09092 5.97506 5.97506 1.09092 12 1.09092C18.0249 1.09092 22.9091 5.97506 22.9091 12C22.9091 18.0249 18.0249 22.9091 12 22.9091Z"
          fill="transparent"
        />
        <path
          d="M13.0834 11.2L17.0001 7H16.0001L12.6334 10.6L10.0001 7H6.66675L10.7667 12.6L6.66675 17H7.66675L11.2167 13.2L14.0001 17H17.3334L13.0834 11.2ZM8.15008 7.66667H9.48341L15.8334 16.3333H14.5001L8.15008 7.66667Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_12168_38184">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default TwitterIcon
